export enum TenantFeatures {
	Forecasting = "forecasting",
	EnableV2 = "enableV2",
	TenantInformation = "tenantInfo",
	FirstTimeLogin = "firstTimeLogin",
	Suite = "Suite",
	DataSourceItemLimit500 = "dataSourceItemLimit500",
	UserRoleTimeAsHoursMinutes = "timeHoursMinutes",
	UserRoleLocation = "userRoleLocation",
	UserUpdates = "userUpdates",
	ReviewerAutomation = "reviewerAutomation",
	NotificationsClearAllButton = "notificationsClearAllButton",
	NotificationActions = "notificationAction",
	AdvancedEmailRule = "advancedEmailRule",
	AdvancedEmailRuleCC = "advancedEmailRuleCC",
	ExpressionBasedCalculationTotals = "expressionBasedCalculationTotals",
	InsightCalculationColumn = "insightCalculationColumn",
	SchedulingExcludeWeekends = "schedulingExcludeWeekends",
	ScheduleCustomDates = "scheduleCustomDates",
	ScheduleMultipleRecords = "scheduleMultipleRecords",
	DomainLogoInSidebar = "domainLogoInSidebar",
	EmailFormats = "emailFormats",
	NewUIOptIn = "newUIOptIn",
	DashboardUsageViews = "dashboardUsageViews",
	DashboardUsageViewsForAllUsers = "dashboardUsageViewsForAllUsers",
	ForecastedColumn = "forecastColumn",
	SchedulingExcludeWeekendsForCustomDates = "schedulingExcludeWeekendsForCustomDates",
	EditDataPermissionBreakdown = "editDataPermissionBreakdown",
	DataSourceListItemCount = "dataSourceListItemCount",
	SubFolders = "subFolders",
	ScheduleFolderMandatory = "scheduleFolderMandatory",
	CadenceEnabledColumn = "cadenceEnabledColumn",
	ScheduleFrequencyDatesCheck = "scheduleFrequencyDatesCheck",
	DataSourceFolders = "dataSourceFolders",
	CadenceId = "cadenceId",
	SourceType = "sourceType",
	CadenceRunningTotals = "cadenceRunningTotals",
	BulkDeleteCases = "bulkDeleteCases",
	BulkDeletePermissions = "bulkDeletePermissions",
	VerticalSideBarAttachments = "verticalSideBarAttachments",
	MultiSelectKeepOpen = "multiSelectKeepOpen",
	FieldColumnHidePermissions = "fieldColumnHidePermissions",
	FieldColumnShowCreatedUpdatedColumns = "fieldColumnShowCreatedUpdatedColumns",
	ScheduleHideStartTime = "scheduleHideStartTime",
	ScheduleHideFrequencyOnceAndToday = "scheduleHideFrequencyOnceAndToday",
	CadenceDefaultSet = "cadenceDefaultSet",
	UiTimezone = "uiTimezone",
	FieldFolders = "fieldFolders",
	TemplateFolders = "templateFolders",
	TeamFolders = "teamFolders",
	SidebarCloseButton="sidebarCloseButton",
	ConsolidatedRecordInfo = "consolidatedRecordInfo",
	HideCalculations = "hideCalculations",
	ScheduleForecastPopup = "scheduleForecastPopup",
	ScheduleTimeZoneColumn = "scheduleTimeZoneColumn",
	ScheduleQuarterlyFrequency = "scheduleQuarterlyFrequency",
	UserTimeManagement = "userTimeManagement",
	DashboardScaleToFit = "dashboardScaleToFit",
	TimeManagementDashTile = "timeManagementTile",
	TimeManagementDashTileEdit = "timeManagementTileEdit",
	PreviousWeekFilter = "previousWeekFilter",
	NextWeekFilter = "nextWeekFilter",
	TimezoneAliases = "timezoneAliases",
	RuleTemplateEditing = "ruleTemplateEditing",
	ViewColumnsShowCreatedUpdatedColumns = "viewColumnsShowCreatedUpdatedColumns",
	UsersCreatedUpdatedColumns = "usersCreatedUpdatedColumns",
	DiagnosticsInfo = "diagnosticsInfo",
	RichTextImages = "richTextImages",
	DataEntryAutoFocus = "dataEntryAutoFocus",
	Triage = "triage",
	PreventInUseDeletion = "preventInUseDeletion",
	InsightInUse = "insightInUse",
	TimeManagementDisplayAvailable = "timeManagementDisplayAvailable",
	ExportLinkToService = "exportLinkToService",
	TextFieldsFormattedExportColumn = "textFieldsFormattedExportColumn",
	FilterByBuiltInUsers = "filterByBuiltInUsers",
	CalculatedFieldExpression = "calculatedFieldExpression",
	ActionsSetValueCadenceEnabled = "actionsSetValueCadenceEnabled",
	ActionsSetValueUserRole = "actionsSetValueUserRole",
	ActionsSetValueUsingFieldOrExpression = "actionsSetValueUsingFieldOrExpression",
	SearchForExternalUsers = "searchForExternalUsers",
	EmailExcludeRecipients = "emailExcludeRecipients",
	CalculatedFieldsDisplayTime = "calculatedFieldsDisplayTime",
	PreferredInsightServers = "preferredInsightServers",
	PdfReports = "pdfReports",
	InheritedTemplateChangeOptions = "inheritedTemplateChangeOptions",
	SourceItemDropdownDisplayAllButton = "sourceItemDropdownDisplayAllButton",
	ReportScheduledEmails = "reportScheduledEmails",
	StickyHeaders = "stickyHeaders",
	TimeManagementOverflow = "timeManagementOverflow",
	FieldMetrics = "fieldMetrics",
	FieldMetricsSLAs = "fieldMetricsSLAs",
	ScheduleDisplayRunTimes = "scheduleDisplayRunTimes",
	UserStatusSchedules = "userStatusSchedules",
	SelectiveInlineEdit = "selectiveInlineEdit",
	NewRichText = "newRichText",
	CloseRecordRuleAction = "closeRecordRuleAction",
	CaseScheduleInfo = "caseScheduleInfo",
	FreezeScheduleManagementFilterOptions = "freezeScheduleManagementFilterOptions",
	BuiltInFieldsInlineEdit = "builtInFieldsInlineEdit",
	InlineEditCenterEditingRow = "inlineEditCenterEditingRow",
	InlineEditMarkEditedRows = "inlineEditMarkEditedRows",
	InsightsFilterByCalculationColumns = "insightsFilterByCalculationColumns",
	ScheduleManagementDisplayAsTime = "scheduleManagementDisplayAsTime",
	ScheduleMakeFromUntilDatesMandatory = "scheduleMakeFromUntilDatesMandatory",
	UserStatusSchedulesDateRangeOverlapWarning = "userStatusSchedulesDateRangeOverlapWarning",
	ReportScheduledEmailsIncludeTime = "reportScheduledEmailsIncludeTime",
	InsightFilterWithCalculations = "insightFilterWithCalculations",
	IntegrationFieldMappingsPerEvent = "integrationFieldMappingsPerEvent",
	ScheduleManagementAvailabilityOnDate = "scheduleManagementAvailabilityOnDate",
	AllowDynamicTemplateSelectionForWebhook = "allowDynamicTemplateSelectionForWebhook",
	DivisionByZeroFormatting = "divisionByZeroFormatting",
	InsightFormattingOptions = "insightFormattingOptions",
	UserRoleFieldHighLatencyUserEnhancements = "userRoleFieldHighLatencyUserEnhancements",
	PercentageCalculations = "percentageCalculations",
	InsightCheckStyleFilters = "insightCheckStyleFilters",
	InsightCheckStyleFiltersShowAvailableValuesOnly = "insightCheckStyleFiltersShowAvailableValuesOnly",
	WorkflowAdjustmentForPictureAttachments = "workflowAdjustmentForPictureAttachments",
	DisplayUserScheduleStatus = "displayUserScheduleStatus",
	CalculationTableCustomFieldsFilter = "calculationTableCustomFieldsFilter",
	AdminShowTemplateId = "adminShowTemplateId",
	InlineEditByRow = "inlineEditByRow",
	ScheduleManagementUseTenancyStartDayOfWeek = "scheduleManagementUseTenancyStartDayOfWeek",
	FieldReassignmentAudit = "fieldReassignmentAudit",
	ShowAddYourselfButtonOnTimeManagementEnabledUserRoles = "showAddYourselfButtonOnTimeManagementEnabledUserRoles",
	TimeCalendarDisabledUserFormattingAndFiltering = "timeCalendarDisabledUserFormattingAndFiltering",
	AdminShowFieldId = "adminShowFieldId",
	AllowMultipleHourFieldsForTimeManagementEnabledUserRole = "allowMultipleHourFieldsForTimeManagementEnabledUserRole",
	TrackTimeSpentFieldsChangesAfterCaseClosure = "trackTimeSpentFieldsChangesAfterCaseClosure",
	TrackTimeSpentFieldsTimeAfterCaseClosure = "trackTimeSpentFieldsTimeAfterCaseClosure",
	StayOnCaseAfterClosure = "stayOnCaseAfterClosure",
	TimeManagementAssignmentDatePerRoleField = "timeManagementAssignmentDatePerRoleField",
	TimeManagementShiftPatternConfig = "timeManagementShiftPatternConfig",
	UserRoleTimeTrackingTimeEntries = "userRoleTimeTrackingTimeEntries",
	FilterTimeManagementUsersByShift = "filterTimeManagementUsersByShift",
	TemplateInheritanceOverride = "templateInheritanceOverride",
	TimeManagementShowPatternsInModal = "timeManagementShowPatternsInModal",
	InsightPresets = "insightPresets",
	TimeManagementWeeklyReportInsightPreset = "timeManagementWeeklyReportInsightPreset",
	RulesEnableDuplication = "rulesEnableDuplication"
}
